export default "__VITE_ASSET__ChRNcDjo__"